// Original code (commented out)
/*
const styleToggleBtn = document.querySelector('.style-toggle-btn')
const toggleBtnStyles = styleToggleBtn.querySelectorAll('span');
const lifestyleStyle = styleToggleBtn.querySelector('.lifestyle-view');
const changeProductImages = () => {
	const productMainImgWrappers = document.querySelectorAll(".product-link .product-item__bg");
	productMainImgWrappers.forEach((wrapper) => {
		const currentMainImg = wrapper.firstChild.querySelector('img')
		console.log('🚀 ~ file: style-toggling.js:9 ~ productMainImgWrappers.forEach ~ wrapper:', wrapper)
		const currentHoverImg = wrapper.closest('.product-link').querySelector('.product-item__bg__under img') ? wrapper.closest('.product-link').querySelector('.product-item__bg__under img') : null
		const hoverWrapper = wrapper.closest('.product-link').querySelector('.product-item__bg__under.no_opac')
		
		if (currentHoverImg) {
			
			let newMainImgSrc
			let newHoverImgSrc
			if (lifestyleStyle.classList.contains('hidden')) {
				newMainImgSrc = wrapper.dataset.lifestyleImage
				newHoverImgSrc = wrapper.dataset.productImage
				// Add 'active' class when lifestyle view is hidden (product is visible)
				if (hoverWrapper) {
					hoverWrapper.classList.add('active')
				}
			} else {
				newMainImgSrc = wrapper.dataset.productImage
				newHoverImgSrc = wrapper.dataset.lifestyleImage
				// Remove 'active' class when lifestyle view is not hidden
				if (hoverWrapper) {
					hoverWrapper.classList.remove('active')
				}
			}
			if (newMainImgSrc && newHoverImgSrc) {
				currentMainImg.setAttribute("src", newMainImgSrc)
				currentMainImg.setAttribute("srcset", newMainImgSrc)
				currentHoverImg.setAttribute("src", newHoverImgSrc)
				currentHoverImg.setAttribute("srcset", newHoverImgSrc)
			}
		}
	})
}
const changeBtnContent = () => {
	toggleBtnStyles.forEach(span => {
		span.classList.toggle('hidden')
	});
}
styleToggleBtn.addEventListener('click', (() => {
	changeProductImages()
	changeBtnContent()
}))
*/

// New toggle code with lifestyle image activation
document.addEventListener('DOMContentLoaded', function() {
  const styleToggleBtn = document.querySelector('.style-toggle-btn');
  
  if (styleToggleBtn) {
    styleToggleBtn.addEventListener('click', function() {
      // Find both span elements within the button
      const productView = this.querySelector('.product-view');
      const lifestyleView = this.querySelector('.lifestyle-view');
      
      // Toggle the hidden class on both spans
      productView.classList.toggle('hidden');
      lifestyleView.classList.toggle('hidden');
      
      // Find all lifestyle image containers and toggle the active class
      const lifestyleImages = document.querySelectorAll('.product-link .product-item__bg__under.product-lifestyle-image.no_opac');
      
      lifestyleImages.forEach(image => {
        // If lifestyle view is visible (doesn't have hidden class), add active class to images
        if (!lifestyleView.classList.contains('hidden')) {
          image.classList.add('active');
        } else {
          image.classList.remove('active');
        }
      });
    });
  }
});